import { SignUpOtpModel, SignUpRepository } from '@/AutoEnrollment/domain'
import { SignUpForm } from '@/AutoEnrollment/ui/hooks'
import { HttpMethod, HttpModel } from '@/Shared/domain'
import { axiosFetch } from '@/Shared/infrastructure'
import { signUp } from '@/Shared/infrastructure/endpoints'

export function createApiSignUpRepository(): SignUpRepository {
  return new ApiSignUpRepository()
}

type SignUpApiForm = {
  email: string
  emailRepeat: string
  userName: string
  password: string
  passwordRepeat: string
  name: string
  surName: string
  surName2: string
  phone: string
  allowWhatsAppContact: boolean
  acceptConditions: boolean
}

const convertFormToApi = (form: SignUpForm): SignUpApiForm => ({
  email: form.email,
  emailRepeat: form.emailRepeat,
  userName: form.username,
  password: form.password,
  passwordRepeat: form.passwordRepeat,
  name: form.name,
  surName: form.surname1,
  surName2: form.surname2 ?? '',
  phone: form.phone,
  allowWhatsAppContact: form.whatsappConsent ?? false,
  acceptConditions: form.acceptConditions,
})

export class ApiSignUpRepository implements SignUpRepository {
  async SignUp(data: SignUpForm): Promise<HttpModel<SignUpOtpModel>> {
    const response = await axiosFetch(signUp, HttpMethod.POST, convertFormToApi(data))

    if (!response.data) {
      return {
        data: {} as SignUpOtpModel,
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }
}
